import { LocationMarker } from './LocationMarker';
import { useMapController } from '../hooks';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Compass, ZoomIn, ZoomOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface MapControllerProps {
    markerPosition: [number, number];
}

export const MapController = ({ markerPosition }: MapControllerProps) => {
    const { t } = useTranslation();
    const { handleZoomIn, handleZoomOut, handleCenterOnMarker } = useMapController({ markerPosition });

    return (
        <div className="absolute top-4 right-4 z-[1000] flex flex-col gap-2 pointer-events-auto">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            type="button"
                            onClick={handleZoomIn}
                            size="icon"
                            variant="outline"
                            className="h-8 w-8 rounded-full shadow-md"
                        >
                            <ZoomIn className="h-4 w-4" />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent side="left">
                        {t('properties.location.zoomIn')}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>

            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            type="button"
                            onClick={handleZoomOut}
                            size="icon"
                            variant="outline"
                            className="h-8 w-8 rounded-full shadow-md"
                        >
                            <ZoomOut className="h-4 w-4" />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent side="left">
                        {t('properties.location.zoomOut')}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>

            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            type="button"
                            onClick={handleCenterOnMarker}
                            size="icon"
                            variant="outline"
                            className="h-8 w-8 rounded-full shadow-md"
                        >
                            <Compass className="h-4 w-4" />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent side="left">
                        {t('properties.location.centerOnMarker')}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>

            <LocationMarker />
        </div>
    );
}; 